// Client-side password checks for a faster error message. The API enforces
// the full policy (including a common-password list) and is the real control.
export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MAX_LENGTH = 128;

export const PASSWORD_REQUIREMENTS = `Use at least ${PASSWORD_MIN_LENGTH} characters. Avoid common passwords and don't reuse your email address.`;

// Returns an error message, or null when the password looks acceptable.
export const getPasswordError = (password, username) => {
  if (!password || password.length < PASSWORD_MIN_LENGTH) {
    return `Password must be at least ${PASSWORD_MIN_LENGTH} characters.`;
  }
  if (password.length > PASSWORD_MAX_LENGTH) {
    return `Password must be at most ${PASSWORD_MAX_LENGTH} characters.`;
  }
  if (!password.trim()) {
    return 'Password cannot be only spaces.';
  }
  if (
    username &&
    password.toLowerCase() === username.trim().toLowerCase()
  ) {
    return 'Password cannot be the same as your email address.';
  }
  return null;
};
